module.exports = __webpack_public_path__ + "media/images/products/IMG_20210704_164341_HDR-removebg-preview-40a7e56fe6f318764c23589cab5e21a4.png";